import { LinkOutlined } from "@ant-design/icons";
import { Form } from "antd";
import type { FC } from "react";

import type { FormField } from "../types/types";
import { EntityLinkIcon, FieldColumnWithLink } from "./FormFieldRenderStyles";

type FieldWithEntityLinkProps = {
    field: FormField;
    fieldComponent: React.JSX.Element;
    buildLinkHref?: (value: string) => string;
};

// Wraps a field with a link icon to the linked entity's own edit page (AP3ADMIN-5014), shown once the field has a value.
export const FieldWithEntityLink: FC<FieldWithEntityLinkProps> = ({ field, fieldComponent, buildLinkHref }) => {
    if (!buildLinkHref) {
        return fieldComponent;
    }

    return (
        <FieldColumnWithLink>
            {fieldComponent}
            <Form.Item noStyle shouldUpdate={() => true}>
                {({ getFieldValue }) => {
                    const value = getFieldValue(field.name);
                    if (!value) {
                        return null;
                    }
                    return (
                        <EntityLinkIcon href={buildLinkHref(value)} target="_blank" rel="noopener noreferrer">
                            <LinkOutlined />
                        </EntityLinkIcon>
                    );
                }}
            </Form.Item>
        </FieldColumnWithLink>
    );
};
